var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 46,
    viewBox: "0 0 300 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_986_2356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7099 41.1013L28.9199 28.2571V0L55.7099 41.1013ZM57.8399 46L28.9199 33.8429V46H57.8399Z",
    fill: "#98002E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13086 41.1013L28.9209 0V28.2571L2.13086 41.1013Z",
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45.9999H28.92V33.8428L0 45.9999Z",
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1791 37.5762C61.2291 37.5762 62.0991 38.4125 62.0991 39.458C62.0991 40.5034 61.2591 41.3697 60.2091 41.3697C59.1591 41.3697 58.2891 40.5333 58.2891 39.4879C58.2891 38.4125 59.1291 37.5762 60.1791 37.5762ZM60.1791 41.071C61.0791 41.071 61.7991 40.3541 61.7991 39.458C61.7991 38.5619 61.0791 37.845 60.1791 37.845C59.2791 37.845 58.5591 38.5619 58.5591 39.458C58.5591 40.3541 59.2791 41.071 60.1791 41.071ZM59.7591 40.5632H59.4891V38.3827H60.3291C60.8391 38.3827 61.0191 38.5918 61.0191 38.9801C61.0491 39.3086 60.7791 39.5775 60.4791 39.6073L61.1391 40.5632H60.8391L60.1791 39.6073H59.7891L59.7591 40.5632ZM59.7591 39.3385H60.1191C60.4191 39.3385 60.7491 39.3086 60.7491 38.9502C60.7491 38.6814 60.4791 38.5918 60.2691 38.5918H59.7891V39.3385H59.7591Z",
    fill: "#98002E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4297 41.1018H93.4197C106.8 41.1018 114.75 34.2018 114.75 22.7616C114.75 11.3213 106.8 4.45117 93.4197 4.45117H80.4297V41.1018ZM88.6497 10.8135H93.4197C102.09 10.8135 106.44 15.0849 106.44 22.7616C106.44 30.4382 102.09 34.7096 93.4197 34.7096H88.6497V10.8135Z",
    fill: "#003D79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.709 25.2109H158.339V18.8486H142.709V10.8135H160.379V4.45117H134.459V41.1018H160.949V34.7395H142.709V25.2109Z",
    fill: "#003D79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.809 34.7395H191.939V4.45117H183.689V41.1018H207.809V34.7395Z",
    fill: "#003D79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.21 4.45117H219.18V10.8135H231.54V41.1018H239.82V10.8135H252.21V4.45117Z",
    fill: "#003D79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 41.1018H291.39L287.79 31.9316H272.82L269.22 41.1018H261.18L276.57 4.30176H284.88L300 41.1018ZM285.45 25.7784L280.32 12.755L275.16 25.7784H285.45Z",
    fill: "#003D79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_986_2356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelta);
export default __webpack_public_path__ + "static/media/delta.a8331579f9f0110632e25725a948b9c7.svg";
export { ForwardRef as ReactComponent };